import React from 'react';
import { inspirations } from '@/data/romaniaHub';
import { ArrowUpRight } from 'lucide-react';

interface Props {
  onInquire: () => void;
}

const TravelInspiration: React.FC<Props> = ({ onInquire }) => {
  return (
    <section id="inspiration" className="py-24 lg:py-32 bg-[#FAF8F3]">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="w-12 h-[1px] bg-[#C9A961]" />
            <span className="font-sans text-[10px] tracking-[0.4em] uppercase text-[#C9A961]">
              The Journal
            </span>
            <div className="w-12 h-[1px] bg-[#C9A961]" />
          </div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#1A3B5C] font-light mb-6">
            Travel Inspiration
          </h2>
          <p className="font-sans text-sm text-[#666] max-w-2xl mx-auto leading-relaxed">
            Editorial guides to help you dream — and design — your perfect Romanian journey.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {inspirations.map((item) => (
            <button
              key={item.title}
              onClick={onInquire}
              className="group text-left bg-white border border-[#E8DFD0] hover:border-[#C9A961]/40 hover:shadow-lg transition-all duration-500 overflow-hidden flex flex-col"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-6 flex flex-col flex-1">
                <h3 className="font-serif text-lg text-[#1A3B5C] font-light mb-3 leading-snug group-hover:text-[#C9A961] transition-colors">
                  {item.title}
                </h3>
                <p className="font-sans text-xs text-[#666] leading-relaxed mb-4">{item.blurb}</p>
                <span className="mt-auto font-sans text-[10px] tracking-[0.2em] uppercase text-[#C9A961] flex items-center gap-1.5">
                  Read More <ArrowUpRight className="w-3.5 h-3.5" />
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TravelInspiration;
